import TextField from '@gerdau/hefesto/TextField/TextField';
import React, { useEffect, useState } from 'react';

interface IAdminBpInputProps {
  title: string;
  customerId: string;
  setCustomerId(customerId: string): void;
  onSearch(customerId: string): void;
  loading: boolean;
  bpError: boolean;
  customerName?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const AdminBpInput: React.FC<IAdminBpInputProps> = ({
  title,
  customerId,
  setCustomerId,
  onSearch,
  loading,
  bpError,
  customerName,
  disabled,
  onChange
}) => {
  const [localValue, setLocalValue] = useState(customerId);

  useEffect(() => {
    setLocalValue(customerId);
  }, [customerId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalValue(value);
    onChange?.(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && localValue.length > 0) {
      setCustomerId(localValue);
      onSearch(localValue);
    }
  };

  const isCommitted = localValue === customerId;

  return (
    <TextField
      label={title}
      name={title}
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={loading || disabled}
      placeholder="Digite o BP"
      maxLength={10}
      variant={bpError && !loading && isCommitted ? 'danger' : undefined}
      supportMessage={
        bpError && !loading && isCommitted
          ? 'BP não encontrado'
          : isCommitted
          ? customerName ?? ''
          : ''
      }
    />
  );
};

export default AdminBpInput;
